import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactTable from '../Utils/ReactTable';
import { Link } from 'react-router-dom';
import { dateFormatting } from '../../Utils';
import { humanizeTotalTimeElapsed } from '../../Utils/charging-point';
import { useTranslation } from 'react-i18next';
import { SESSION_START_TYPE } from '../../Constants';
const SessionsTable = ({ tableData, csvData }) => {
  const data = useMemo(() => tableData, [tableData]);
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        Header: t('user'),
        accessor: 'user',
        Cell: ({ cell }) => (
          <Link
            className='link'
            to={`/reports/session?cp=${cell.row.original.chargePointId}&id=${cell.row.original.id}`}>
            {cell.row.original.user?.email || '-'}
          </Link>
        )
      },
      {
        Header: t('start_date'),
        accessor: 'createdAt',
        Cell: ({ cell }) => dateFormatting(cell.row.original.createdAt)
      },
      {
        Header: t('end_date'),
        accessor: 'endDate',
        Cell: ({ cell }) => dateFormatting(cell.row.original.endDate)
      },
      {
        Header: t('duration'),
        accessor: 'total_time_elapsed',
        Cell: ({ cell }) =>
          cell.row.original.endDate && cell.row.original.createdAt
            ? humanizeTotalTimeElapsed(
                new Date(cell.row.original.endDate) - new Date(cell.row.original.createdAt)
              )
            : '-'
      },
      {
        Header: t('total_energy_kwh'),
        accessor: 'totalEnergyConsumed',
        Cell: ({ cell }) => {
          // Use session.totalEnergyConsumed directly (V2 now stores energy on session like V1)
          const totalEnergyWh = cell.row.original.totalEnergyConsumed ?? 0;
          return (Number(totalEnergyWh) / 1000).toFixed(2);
        }
      },
      {
        Header: t('price_per_kw'),
        accessor: 'paymentIntent.amount',
        Cell: ({ cell }) => {
          // Use session.totalEnergyConsumed directly
          const totalEnergy = (cell.row.original.totalEnergyConsumed ?? 0) / 1000;
          const amount = cell.row.original.paymentIntent?.amount || 0;
          return totalEnergy ? (amount / totalEnergy).toFixed(2) : '0.00';
        }
      },
      {
        Header: t('session_price'),
        accessor: 'session_price',
        Cell: ({ cell }) => {
          // Use session.totalEnergyConsumed directly
          const totalEnergy = (cell.row.original.totalEnergyConsumed ?? 0) / 1000;
          const amount = cell.row.original.paymentIntent?.amount || 0;
          const pricePerKw = totalEnergy ? amount / totalEnergy : 0;
          return <span>{(pricePerKw * totalEnergy).toFixed(2)}</span>;
        }
      },
      {
        Header: t('parent_org'),
        accessor: 'parent_organization',
        className: 'ellipsis',
        Cell: ({ cell }) => {
          return <p>{cell.row.original.user?.parentOrganization?.name || '-'}</p>;
        }
      },
      {
        Header: t('label'),
        accessor: 'label',
        Cell: ({ cell }) => cell.row.original.label || '-'
      },
      {
        Header: t('Start'),
        accessor: 'start',
        Cell: ({ cell }) => {
          return cell.row.original.start;
        }
      },
      {
        Header: t('rfid_tag_id'),
        accessor: 'rfid_tag_id',
        Cell: ({ cell }) =>
          cell.row?.original?.rfidTag?.value || <span className='web-tag'>web</span>
      }
    ],
    [tableData]
  );

  return (
    <ReactTable className='no-wrap' data={data} columns={columns} csvData={csvData} exportCsv />
  );
};

SessionsTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  csvData: PropTypes.array
};

export default SessionsTable;
